import { Link } from 'react-router-dom'
import { Wrench } from 'lucide-react'
import { t } from '@/lib/ui'

// "Konepellin alle" (under the hood) — the affordance on every FI surface that
// renders vault-derived facts, linking to the raw spec at /spec/:id
// (DESIGN-BRIEF §2 cross-linking rule; the "everything is specs" proof). Later
// WPs drop this beside any vault-sourced content.

interface KonepellinAlleProps {
  specId: string
  className?: string
}

export function KonepellinAlle({ specId, className = '' }: KonepellinAlleProps) {
  return (
    <Link
      to={`/spec/${specId}`}
      className={`inline-flex items-center gap-1.5 text-sm text-muted transition-colors hover:text-accent ${className}`}
      title={t('konepellinAlle.hint')}
    >
      <Wrench className="h-3.5 w-3.5" aria-hidden="true" />
      <span className="underline decoration-hairline underline-offset-2">
        {t('konepellinAlle.label')}
      </span>
      <span className="font-mono text-xs">{specId}</span>
    </Link>
  )
}
